<div class="info-dialog-header">
  <h3 class="title">{{ title }}</h3>
  <hr />
</div>  
<div class="info-dialog-content">
  <div class="overflow-content">
    <div *ngIf="info.turndownReasons.length > 0 && showTurndownReason">
      <h4>Turndown Reason</h4>
      <div class="comment-box">
        <ol>
          <li *ngFor="let reason of info.turndownReasons">{{ reason.title }}</li>
        </ol>
      </div>
    </div>
    <div *ngIf="info.turndownComment && showTurndownReason">
      <h4>Turndown Comment</h4>
      <div class="comment-box">{{ info.turndownComment }}</div>
    </div>
    <div *ngIf="info.finalComment && showFinalComment">
      <h4>Final Comment</h4>
      <div class="comment-box">{{ info.finalComment }}</div>
    </div>
  </div>
</div>
<div class="info-dialog-footer">
  <button type="button" class="button button-primary" (click)="close()" attr.aria-label="Close modal">
    Close
  </button>
</div>